module.exports = __webpack_public_path__ + "static/media/6.e0e74d16.JPG";